module.exports = __webpack_public_path__ + "static/img/bar1.5b61ee5b.jpg";